<template>
  <div class="popups">
    <p class="name">
      <slot name="name"></slot>
    </p>
    <div class="rectangle">
      <div class="panel" @click="deviceAdmin('detail')">
        <span>设备详情</span>
        <p>查看</p>
        <div class="panel-footer"></div>
      </div>
      <div
        class="panel"
        v-if="deviceInfo.hasVideo"
        @click="deviceAdmin('real')"
      >
        <span>视频监控</span>
        <p>实时</p>
        <div class="panel-footer"></div>
      </div>
      <div class="panel" @click="deviceAdmin('history')">
        <span>历史轨迹</span>
        <p>信息</p>
        <div class="panel-footer"></div>
      </div>
      <div class="panel" @click="deviceAdmin('alarm')">
        <!-- <span>风险事件</span> -->
        <span>设备报警</span>
        <p>查询</p>
        <div class="panel-footer"></div>
      </div>
    </div>

    <div class="information">
      <p class="equipmentNo">
        <i class="el-icon-c-scale-to-original"></i>&nbsp;<slot
          name="equipmentNo"
        >
        </slot>
        <span class="data">
          <slot name="carStatusLabel"></slot>
          <slot name="modelLabel"></slot>
        </span>
      </p>
      <p class="locationTime">
        <i class="el-icon-time"></i>&nbsp;<slot name="locationTime"
          >2022-02-22 22:22:22</slot
        >
      </p>
      <p class="address">
        <i class="el-icon-location-information"></i>&nbsp;<slot
          name="address"
        ></slot>
      </p>
    </div>
    <div class="someInfo">
      <div class="projectName">
        <span style="width: 100px">所属项目： </span>
        <slot name="projectName"></slot>
      </div>
      <div class="TwoBox">
        <div class="operators">
          <span>操作手： </span><slot name="operators"></slot>
        </div>
        <div class="status">
          <span>设备状态：</span> <slot name="status"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["deviceInfo"],
  methods: {
    deviceAdmin(info) {
      this.$router.push({
        path: "/deviceManage",
        query: {
          where: info,
          deviceInfo: this.deviceInfo,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.popups {
  width: 360px;
  z-index: 999;
  margin: auto;
  background: #fff;
  cursor: context-menu;
  font-size: 14px;
  .name {
    text-align: center;
    font-weight: bolder;
    font-size: 20px;
    color: rgb(45, 23, 23);
  }

  .rectangle {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;

    .panel {
      position: relative;
      width: 70px;
      height: 66px;
      border: 2px solid #abb4b7;
      border-radius: 3px;
      background-color: #fff;
      margin: 6px;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: space-around;
      cursor: pointer;

      &::before {
        content: "";
        position: absolute;
        top: -6px;
        left: -6px;
        width: 5px;
        height: 5px;
        border-left: 2px solid #d0e4e4;
        border-top: 2px solid #d0e4e4;
      }

      &::after {
        content: "";
        position: absolute;
        top: -6px;
        right: -6px;
        width: 5px;
        height: 5px;
        border-right: 2px solid #d0e4e4;
        border-top: 2px solid #d0e4e4;
      }

      .panel-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        &::before {
          content: "";
          position: absolute;
          bottom: -6px;
          left: -6px;
          width: 5px;
          height: 5px;
          border-left: 2px solid #d0e4e4;
          border-bottom: 2px solid #d0e4e4;
        }

        &::after {
          content: "";
          position: absolute;
          bottom: -6px;
          right: -6px;
          width: 5px;
          height: 5px;
          border-right: 2px solid #d0e4e4;
          border-bottom: 2px solid #d0e4e4;
        }
      }

      p {
        font-size: 10px;
        color: rgb(108, 93, 93);
      }

      span {
        font-weight: bold;
        padding-top: 10px;
      }
    }
  }

  .information {
    display: flex;
    flex-direction: column;
    // margin-top: 10px;
    margin-left: 10px;
    padding-bottom: 10px;
    border-bottom: 1px gray dotted;
    .equipmentNo {
      position: relative;
      display: flex;
      .data {
        position: absolute;
        right: 0px;
        span {
          margin-right: 20px;
        }
      }
    }
    p {
      margin-top: 10px;
      color: #4a5458;
    }
  }

  .someInfo {
    .TwoBox {
      display: flex;
      justify-content: space-between;
    }
    .projectName {
      padding: 12px 0 8px 0;
    }
    .operators {
    }
    .status {
    }
  }
}
</style>
